import LayerMappingsEnum from "../../enums/LayerMappingsEnum";
import ISceneGeometry from "../sceneObject/ISceneGeometry";
import ChecklistItemData from "../sceneObjectData/ChecklistItemData";
import SceneObjectData from "../sceneObjectData/SceneObjectData";
import CompoundSceneGeometry from "./CompoundSceneGeometry";
import ChecklistItemSubGeometry2d from "./ChecklistItemSubGeometry2d";
import ChecklistItemSubGeometry3d from "./ChecklistItemSubGeometry3d";

export default class ChecklistItemCompoundGeometry extends CompoundSceneGeometry<ChecklistItemData> {

    geometry2d: ChecklistItemSubGeometry2d = new ChecklistItemSubGeometry2d();
    geometry3d: ChecklistItemSubGeometry3d = new ChecklistItemSubGeometry3d();

    constructor() {
        super();

        this.group.add(this.geometry2d.group);
        this.group.add(this.geometry3d.group);
    }

    protected getSubGeometries(): ISceneGeometry[] {
        return [this.geometry2d, this.geometry3d];
    }

    onAnnotationDirectionChange(rotationOffset: number): void {
        this.geometry2d.onAnnotationDirectionChange(rotationOffset);
        // No need to rotate 3d geometry 
    }

    protected updateGeometry(data: SceneObjectData, forceUpdate: boolean): boolean {
        const result = super.updateGeometry(data, forceUpdate);

        this.geometry2d.setLayer(LayerMappingsEnum.Annotations2d);
        this.geometry3d.setLayer(LayerMappingsEnum.Annotations3d);

        return result;
    }
}
